/* Tysk katalog for locale-bank-kje09-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'bank.group.toast.booked': 'Die Abgleichsgruppe wurde gemeinsam gebucht.',
  'bank.group.err.bookUnavailable': 'Die Abgleichsgruppe wurde genehmigt, aber das Buchen ist nicht verfügbar.',
  'bank.group.err.bookFailed': 'Die Abgleichsgruppe konnte nicht gebucht werden.',
  'bank.group.book': 'Gruppe buchen',
  'bank.resolve.reversePaymentInfo': 'Die Stornierung hebt die Zahlung nachvollziehbar auf, öffnet die Lieferantenrechnung wieder und gibt die Bankzeile zur erneuten Prüfung frei.',
  'err.bankMatchReversalReason': 'Gib einen Grund für die Stornierung der Bankverknüpfung an.',
});
